import { Moon, Sun } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Logo } from '@/components/shared/Logo'
import { useAuth } from '@/lib/firebase/auth'
import { useTheme } from '@/hooks/useTheme'
import { NavFooter, NavItems } from './nav-items'

function ThemeButton() {
  const { resolvedTheme, setTheme } = useTheme()
  return (
    <Button
      variant="ghost"
      size="sm"
      className="flex-1 justify-start"
      onClick={() => setTheme(resolvedTheme === 'dark' ? 'light' : 'dark')}
    >
      {resolvedTheme === 'dark' ? <Sun className="size-4" /> : <Moon className="size-4" />}
      Theme
    </Button>
  )
}

/** Persistent sidebar. Hidden below md, where MobileNav's drawer takes over. */
export function Sidebar({ email, role }: { email?: string; role?: string }) {
  const { signOutAdmin } = useAuth()

  return (
    <aside className="hidden w-56 shrink-0 flex-col border-r bg-sidebar text-sidebar-foreground md:flex">
      <div className="flex items-center gap-2 px-4 py-4">
        <Logo className="size-6" />
        <span className="font-display text-base font-semibold tracking-tight">VOYP Admin</span>
      </div>
      <NavItems role={role} />
      <NavFooter
        email={email}
        role={role}
        onSignOut={() => void signOutAdmin()}
        theme={<ThemeButton />}
      />
    </aside>
  )
}

/** Drawer contents, reused by MobileNav. */
export function SidebarContents({
  email,
  role,
  onNavigate,
}: {
  email?: string
  role?: string
  onNavigate: () => void
}) {
  const { signOutAdmin } = useAuth()

  return (
    <div className="flex h-full flex-col">
      <NavItems onNavigate={onNavigate} role={role} />
      <NavFooter
        email={email}
        role={role}
        onSignOut={() => void signOutAdmin()}
        theme={<ThemeButton />}
      />
    </div>
  )
}
